import { Component } from '@angular/core';
import { Action, ActionType } from 'src/app/models/action';
import { HoldStatus } from 'src/app/models/physical-record';
import { RecordButtonsComponent } from '../record-buttons/record-buttons.component';

@Component({
  selector: 'app-hold-physical-button',
  templateUrl: './hold-physical-button.component.html',
  styleUrls: ['./hold-physical-button.component.scss', '../base-button.scss'],
})
export class HoldPhysicalButtonComponent extends RecordButtonsComponent {
  hold() {
    const action: Action = {
      type: ActionType.HOLD,
      recordId: this.physicalRecord.recordId,
    };

    this.doAction(
      () => {
        this.analyticsService.sendHoldStartEvent();
        this.holdsFacade
          .postHold(
            this.physicalRecord.recordId,
            this.getCurrentScreen(),
            this.issueDate,
            this.rhId
          )
          .subscribe(() => {
            this.toastService.showToast('messages.new.hold');
            this.analyticsService.sendHoldEndEvent();
            this.waiting = false;
            this.physicalRecord.holdInfo = HoldStatus.ALREADY_HELD;
          });
      },
      action,
      true
    );
  }
}
